import { SurveyElementTypeEnum, SurveyInputTypeEnum, } from "../../../types/forms";
export var getFieldComponent = function (element) {
    var type = element.type, inputType = element.inputType;
    switch (type) {
        case "text":
            switch (inputType) {
                case "email":
                    return SurveyInputTypeEnum.EMAIL;
                case "url":
                    return SurveyInputTypeEnum.URL;
                case "number":
                    return SurveyInputTypeEnum.NUMBER;
                case "date":
                    return SurveyInputTypeEnum.DATE;
                case "datetime-local":
                    return SurveyInputTypeEnum.DATETIME_LOCAL;
                case "tel":
                    return SurveyInputTypeEnum.TEL;
                case "password":
                    return SurveyInputTypeEnum.PASSWORD;
                default:
                    return SurveyInputTypeEnum.TEXT;
            }
        case "comment":
            return SurveyElementTypeEnum.COMMENT;
        case "dropdown":
            return SurveyElementTypeEnum.DROPDOWN;
        case "radiogroup":
            return SurveyElementTypeEnum.RADIOGROUP;
        case "checkbox":
            return SurveyElementTypeEnum.CHECKBOX;
        case "boolean":
            return SurveyElementTypeEnum.BOOLEAN;
        case "file":
            return SurveyElementTypeEnum.FILE;
        case "imagepicker":
            return SurveyElementTypeEnum.IMAGEPICKER;
        case "rating":
            return SurveyElementTypeEnum.RATING;
        case "ranking":
            return SurveyElementTypeEnum.RANKING;
        case "matrix":
            return SurveyElementTypeEnum.MATRIX;
        case "matrixdropdown":
            return SurveyElementTypeEnum.MATRIXDROPDOWN;
        case "matrixdynamic":
            return SurveyElementTypeEnum.MATRIXDYNAMIC;
        case "multipletext":
            return SurveyElementTypeEnum.MULTIPLETEXT;
        case "tagbox":
            return SurveyElementTypeEnum.TAGBOX;
        case "panel":
            return SurveyElementTypeEnum.PANEL;
        case "signaturepad":
            return SurveyElementTypeEnum.SIGNATUREPAD;
        case "image":
            return SurveyElementTypeEnum.IMAGE;
        case "html":
            return SurveyElementTypeEnum.HTML;
        case "expression":
            return SurveyElementTypeEnum.EXPRESSION;
        default:
            return SurveyElementTypeEnum.TEXT;
    }
};
